import { serviceClient, utils } from '@yola/ws-sdk';
import asyncJobStatuses from '../../common/constants/async-job-statuses';

const POLLING_INTERVAL = 500;

const initiateUnsplashSearchQueryGeneration = async () => {
  const client = serviceClient.get();
  const response = await client.initiateUnsplashSearchQueryGeneration();
  const {
    data: { id: jobId, status },
  } = response;

  switch (status) {
    case asyncJobStatuses.COMPLETE: {
      return response.data;
    }
    case asyncJobStatuses.FAILED: {
      throw response.data;
    }
    default: {
      return utils.pollAsyncJob({ jobId, interval: POLLING_INTERVAL });
    }
  }
};

export default initiateUnsplashSearchQueryGeneration;
